export default __webpack_public_path__ + "static/media/student_history_icon.8fbdadfc.svg";